import AsyncGqlTable from './AsyncGqlTable.vue';

export default AsyncGqlTable;
